module.exports = __webpack_public_path__ + "img/asset_FTT.a3be707a.svg";